import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/shared/foundation/i18n/language.service';
import { SettingsService } from 'src/app/shared/foundation/settings/settings.service';

@Component({
  selector: 'app-language-switch',
  templateUrl: './language-switch.component.html',
  styleUrls: ['./language-switch.component.scss'],
})
export class LanguageSwitchComponent implements OnInit {
  readonly availableLocales = ['de', 'en'];
  readonly prefix = 'languageSwitch.';

  showLanguageSelection: boolean = false;

  constructor(
    private $languageService: LanguageService,
    private $settingsService: SettingsService,
    private $translateService: TranslateService
  ) {}

  ngOnInit(): void {}

  filterAvailableLocales(currentLang: string): string[] {
    return this.availableLocales.filter(
      (x) => x.toLowerCase() !== currentLang.toLowerCase()
    );
  }

  get localeId(): string {
    return (
      this.$translateService.currentLang || this.$settingsService.getLocaleId()
    );
  }

  changeLanguage(langSelect: string): void {
    this.$languageService.setLanguage(langSelect);
  }
}
